import styled, { css } from 'styled-components'
import externalSVG from '../images/external.svg'
import externalSVGWhite from '../images/external_white.svg'

const buttonStyles = {
  primary: css`
    background-color: var(--primary-color);
    border-color: var(--primary-color);
    color: var(--white);

    &:hover {
      color: var(--primary-color);
      background-color: var(--white);
      border-color: var(--white);
      box-shadow: 0px 0px 0px 2px var(--primary-color-light);
    }

    &:focus {
      color: var(--white);
      background-color: var(--primary-color);
      border-color: var(--primary-color);
      box-shadow: 0px 0px 0px 2px var(--primary-color-light);
    }
  `,

  // grey: css`
  //   color: var(--white);
  //   background-color: var(--grey);
  //   border-color: var(--grey);

  //   &:hover {
  //     background-color: var(--dark-grey);
  //     border-color: var(--dark-grey);
  //   }

  //   &:focus {
  //     color: var(--white);
  //     background-color: var(--white);
  //     border-color: var(--white);
  //     box-shadow: 0px 0px 0px 2px lighten(var(--grey), 10%);
  //   }
  // `,

  default: css`
    background-color: var(--white);
    border-color: var(--white);
    color: var(--primary-color);

    &:hover {
      color: var(--white);
      background-color: var(--primary-color);
      border-color: var(--primary-color);
    }

    &:focus {
      color: var(--primary-color);
      background-color: var(--white);
      border-color: var(--white);
      box-shadow: 0px 0px 0px 2px var(--primary-color-light);
    }
  `,
}

export const Button = styled.a`
  display: inline-block;
  min-width: 18rem;
  font-weight: var(--global-weight-bold);
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid;
  padding: 1rem 4rem;
  font-size: 1.2rem;
  line-height: 1.5;
  letter-spacing: 1.71px;
  text-transform: uppercase;
  transition: color 0.2s ease-out, border-color 0.2s ease-out,
    background-color 0.2s ease-out, box-shadow 0.2s ease-out;
  box-shadow: 0;
  border-radius: ${(props) => (props.rounded ? '2rem' : '0.25rem')};

  &:focus {
    outline: 0;
  }

  &:not(:disabled):not(.disabled) {
    cursor: pointer;
  }

  & + & {
    margin: 1rem;
  }

  ${(props) =>
    props.variant ? buttonStyles[props.variant] : buttonStyles['primary']}

  ${(props) =>
    props.external &&
    css`
      &::after {
        content: url(${externalSVG});
        margin-left: 1rem;
        vertical-align: text-top;
      }

      &:hover {
        &::after {
          content: url(${externalSVGWhite});
        }
      }
    `}
`
